export const toBase64 = (img: any): string => {
  if (!img) return '';
  return img.startsWith('data:image') ? img : `data:image/jpeg;base64,${img}`;
};
